export default __webpack_public_path__ + "static/media/loading-github.ed18f098.gif";